<template>
    <footer class="footer wow fadeInUp">
        <div class="wp">
            <div class="fd-top">
                <!-- <div class="left">
                    <a :href="fdData.footNameHyperlink" target="_blank" class="name">{{ fdData.footName }}</a>
                    <div class="tel-mod">
                        <p>
                            <span class="icon">
                                <i></i>
                            </span>
                            <span>{{ fdData.footPhoneOne }}</span>
                        </p>
                        <em>24小时服务热线</em>
                    </div>
                </div> -->
                <div class="right">
                    <dl>
                        <dt>联系地址</dt>
                        <dd>{{fdData.footAddress}}</dd>
                        <p>{{ fdData.footPhoneOne }}</p>
                    </dl>
                    <dl>
                        <dt>关注我们</dt>
                        <dd style="opacity:1"><img src="@/assets/images/gzh.jpg" alt="" width="120" height="120"></dd>
                    </dl>
                    <dl>
                        <dt>视频号</dt>
                        <dd style="opacity:1"><img src="@/assets/images/hyyy.jpg" alt="" width="120" height="120"></dd>
                    </dl>
<!--                    <dl>-->
<!--                        <dt>工作时间</dt>-->
<!--                        <dd>{{ fdData.footJobTime }}</dd>-->
<!--                        <dd>{{fdData.footJobMorning}}</dd>-->
<!--                        <dd>{{fdData.footJobAfternoon}}</dd>-->
<!--                    </dl>-->
                    <dl v-show="fdData.latitude && fdData.longitude">
                        <dt>地图</dt>
                        <dd style="opacity: 1;">
                            <!-- <a href="https://map.baidu.com/search/%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA%E4%B8%8A%E5%9C%B0%E4%B8%9C%E8%B7%AF%E4%BA%94%E5%8F%B7%E4%BA%AC%E8%92%99%E9%AB%98%E7%A7%91%E5%A4%A7%E5%8E%A6/@12947814.273990523,4846489.76552725,19z?querytype=s&da_src=shareurl&wd=%E5%8C%97%E4%BA%AC%E5%B8%82%E6%B5%B7%E6%B7%80%E5%8C%BA%E4%B8%8A%E5%9C%B0%E4%B8%9C%E8%B7%AF%E4%BA%94%E5%8F%B7%E4%BA%AC%E8%92%99%E9%AB%98%E7%A7%91%E5%A4%A7%E5%8E%A6&c=153&src=0&pn=0&sug=0&l=12&b=(12476623.255364142,4078107.739372796;12554686.0860691,4116244.6847901135)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&device_ratio=1" class="map-wrap" target="_blank">
                                <div id="map" class="map"></div>
                            </a> -->
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="fd-link">
                <span>友情链接 :</span>
                <a :href="item.hyperlink" target="_blank" v-for="(item,index) in linkList" :key="index">{{ item.title }}</a>
            </div>
            <div class="copyright">
                <a href="https://beian.miit.gov.cn" target="_blank">{{ copyRight }}</a>
            </div>
        </div>
    </footer>
</template>
<script>
import {WOW} from "wowjs";
import {headerFooterApi, homeListApi} from "@/api";
import Swiper from "swiper";
export default {
    name: "PageFooter",
    data() {
        return {
            linkList: [],
            copyRight: '',
            fdData:{}
        }
    },
    mounted() {
        new WOW({live: false}).init();
        this.getLink()
        this.getCopyright()

        headerFooterApi().then(res => {
            if (res.code === 200){
                this.fdData = res.data;
                if (this.fdData.latitude && this.fdData.longitude){
                    // this.initMap()
                }

            }
        })


    },
    methods:{
        initMap:function () {
            // var map = new BMapGL.Map('map');
            // map.centerAndZoom(new BMapGL.Point(this.fdData.longitude, this.fdData.latitude), 16);
            // map.enableScrollWheelZoom(true);
            // // 创建点标记
            // var marker1 = new BMapGL.Marker(new BMapGL.Point(this.fdData.longitude, this.fdData.latitude));
            // // 在地图上添加点标记
            // map.addOverlay(marker1);
        },
        getLink:function () {
            homeListApi({type: 8, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                    this.linkList = res.rows
                }
            })
        },
        getCopyright:function () {
            homeListApi({type: 9, pageNum: 1, pageSize: 100}).then(res => {
                if (res.code === 200) {
                     this.copyRight  = res.rows[0].title
                }
            })
        },
    }
}
</script>


<style scoped lang="scss">

</style>
